import { useState } from "react";
import Interactor from "../Interactors/Interactor";
// import { genTBL } from "../../utils";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";

import CloseIcon from "@mui/icons-material/Close";

const DUMMY_RESTRAINTS = [
  {
    id: "1",
    active: null,
    passive: null,
    chain: null,
    partner: null,
  },
  {
    id: "2",
    active: null,
    passive: null,
    chain: null,
    partner: null,
  },
];

const BuilderForm = (props: any) => {
  const [restraints, manipulateInteractor] = useState(DUMMY_RESTRAINTS);
  const [combinationError, setCombinationError] = useState(false);
  const [actPasError, setActPasError] = useState(false);
  const [notEnoughInteractorsError, setnotEnoughInteractorsError] =
    useState(false);
  const [interactorError, setInteractorError] = useState(false);
  const [partnerError, setPartnerError] = useState(false);

  let combinationErrorText =
    "Interactors with only passive must have a partner with active.";
  let actPasErrorText =
    "Interactors must be defined either with passive or active residues.";
  let notEnoughInteractorsErrorText = "Must have at least 2 interactors.";
  let partnerErrorText = "Interactor IDs and partner definition don't match.";

  const handleFormSubmit = (event: React.FormEvent<EventTarget>) => {
    // Handles the form submission
    event.preventDefault();

    // Check if there are either active or passive defined for each interactor
    if (!hasActOrPas(restraints)) {
      setActPasError(true);
      console.log(
        "There are no active or passive defined for each interactor."
      );
      return;
    } else {
      setActPasError(false);
    }

    // Check if an interactor without passive has a partner with active
    console.log(restraints);
    if (!hasValidCombination(restraints)) {
      setCombinationError(true);
      return;
    } else {
      setCombinationError(false);
    }

    // Check if the partners are fulfilled
    if (!partnersExist(restraints)) {
      setPartnerError(true);
      return;
    } else {
      setPartnerError(false);
    }

    // ------------------------------------
    // The logic to generate the TBL goes here
    var arr: string[] = [];
    for (var i = 0; i < restraints.length; i++) {
      var chain = restraints[i].chain;
      var active = restraints[i].active;
      var passive = restraints[i].passive;
      var partner = restraints[i].partner;
      let inp = chain + " " + active + " " + passive + " " + partner;
      inp = inp.replace("null", "");
      arr.push(inp);
    }
    let tbl = window.GenTBLWrapper(arr);
    // ------------------------------------

    props.onGeneration(tbl);
  };

  const handleAddClick = () => {
    // Adds a new object to the array
    // id must be unique, get the largest id and add 1
    // -- aka add a new Interactor
    let highestId = Math.max(
      ...restraints.map((restraints) => parseInt(restraints.id))
    );
    manipulateInteractor([
      ...restraints,
      {
        id: String(highestId + 1),
        active: null,
        passive: null,
        chain: null,
        partner: null,
      },
    ]);
  };

  const handleRemoveClick = (id: any) => {
    // Remove a specific object from the array
    //  -- aka remove one of the Interactor
    // We need to have at least 2 interactors
    if (restraints.length > 2) {
      console.log("from Builder.js - removing interactor with id: ", id);
      let array = [...restraints];
      let index = array.findIndex((item) => item.id === id);
      array.splice(index, 1);
      manipulateInteractor(array);
    } else {
      setnotEnoughInteractorsError(true);
      console.log("Need at least 2 interactors");
    }
  };

  const handleChangeValues = (id: any, field: any, value: any) => {
    // This function listens to values being changed in the Interactor component
    //  and updates the current restraints array
    let array = [...restraints];
    let index = array.findIndex((item) => item.id === id);
    // @ts-ignore
    array[index][field] = value;
    manipulateInteractor(array);
    if (restraints.length <= 2) {
      setnotEnoughInteractorsError(false);
    }
  };

  // Handle errors coming from the interactor
  const handleInteractorError = (error: boolean) => {
    setInteractorError(error);
  };

  // Check if an interactor without passive has a partner with active
  const hasValidCombination = (restraints: any): boolean => {
    // For each interactor
    for (var i = 0; i < restraints.length; i++) {
      // If it does not have an active selection
      if (!restraints[i].active) {
        // Identify its partners
        let p = restraints[i].partner.split(",");
        // For each partner
        for (var j = 0; j < p.length; j++) {
          let partnerId = p[j];
          // Find the array of the partner
          for (var k = 0; k < restraints.length; k++) {
            if (restraints[k].id === partnerId) {
              // Check if the partner has an active selection
              if (!restraints[k].active) {
                // Partner does not have active
                return false;
              }
            }
          }
        }
      }
    }
    return true;
  };

  // Check if the defined partners exist
  const partnersExist = (restraints: any): boolean => {
    let partnerArray: string[] = [];
    let interactorArray: string[] = [];
    let missingArray: string[] = [];
    for (var i = 0; i < restraints.length; i++) {
      interactorArray.push(restraints[i].id);
      let p: string[] = restraints[i].partner.split(",");
      for (var j = 0; j < p.length; j++) {
        partnerArray.push(p[j]);
      }
    }
    for (var k = 0; k < partnerArray.length; k++) {
      if (!interactorArray.includes(partnerArray[k])) {
        missingArray.push(partnerArray[k]);
      }
    }
    if (missingArray.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  // Check if interactors have either active or passive defined
  const hasActOrPas = (restraints: any): boolean => {
    let arr: boolean[] = [];
    for (var i = 0; i < restraints.length; i++) {
      if (!restraints[i].active && !restraints[i].passive) {
        // Does not have active and passive
        arr.push(false);
      } else if (restraints[i].active || restraints[i].passive) {
        // has either active or passive
        arr.push(true);
      }
    }
    // returns true if all are true
    return arr.every((element) => element === true);
  };

  // Render the Interactor components based on how many
  //  elements there are in the restraints array
  const interactorlist = restraints.map((restraints) => (
    <Interactor
      items={restraints}
      key={restraints.id}
      id={restraints.id}
      onChangeValue={handleChangeValues}
      onRemoveBtnPress={handleRemoveClick}
      error={handleInteractorError}
    />
  ));

  return (
    <form onSubmit={handleFormSubmit} style={{ marginTop: "20px" }}>
      {interactorlist}

      {/* -------------------------------------------------------- */}
      {/* Warnings */}
      <Collapse in={notEnoughInteractorsError}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setnotEnoughInteractorsError(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
          severity="warning"
        >
          {notEnoughInteractorsErrorText}
        </Alert>
      </Collapse>

      <Collapse in={combinationError}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setCombinationError(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
          severity="error"
        >
          {combinationErrorText}
        </Alert>
      </Collapse>

      <Collapse in={actPasError}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setActPasError(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
          severity="error"
        >
          {actPasErrorText}
        </Alert>
      </Collapse>

      <Collapse in={partnerError}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setPartnerError(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
          severity="error"
        >
          {partnerErrorText}
        </Alert>
      </Collapse>

      {/* End of warnings */}
      {/* -------------------------------------------------------- */}

      <Grid
        container
        spacing={2}
        // direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={4}>
          <Button variant="outlined" type="button" onClick={handleAddClick}>
            Add Interactor
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button variant="contained" type="submit" disabled={interactorError}>
            Generate Restraints
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default BuilderForm;
